import { Platform } from 'react-native';
import * as FileSystem from 'expo-file-system';
import AsyncStorage from '@react-native-async-storage/async-storage';

const STORAGE_PREFIX = 'piclo-image-';

let localforagePromise: Promise<any> | null = null;

const getLocalforage = async () => {
  if (!localforagePromise) {
    localforagePromise = import('localforage').then((module) => {
      const lf = module.default;
      lf.config({
        name: 'piclo',
        storeName: 'piclo_images',
        description: 'Piclo image storage',
      });
      return lf.setDriver(lf.INDEXEDDB).then(() => lf);
    });
  }
  return localforagePromise;
};

const stripDataUrlPrefix = (dataUrl: string) => {
  const commaIndex = dataUrl.indexOf(',');
  return commaIndex >= 0 ? dataUrl.slice(commaIndex + 1) : dataUrl;
};

export const saveImage = async (id: string, base64DataUrl: string): Promise<string> => {
  if (Platform.OS === 'web') {
    const key = `${STORAGE_PREFIX}${id}-${Date.now()}`;
    const localforage = await getLocalforage();
    await localforage.setItem(key, base64DataUrl);
    return key;
  }

  const fileName = `${STORAGE_PREFIX}${id}-${Date.now()}.png`;
  const fileUri = `${FileSystem.documentDirectory}${fileName}`;
  const base64 = stripDataUrlPrefix(base64DataUrl);

  await FileSystem.writeAsStringAsync(fileUri, base64, {
    encoding: FileSystem.EncodingType.Base64,
  });

  return fileUri;
};

export const loadImage = async (storageUri: string): Promise<string | null> => {
  if (Platform.OS === 'web') {
    if (storageUri.startsWith('data:image/')) {
      return storageUri;
    }
    const localforage = await getLocalforage();
    const value = await localforage.getItem<string>(storageUri);
    return value ?? null;
  }

  return storageUri;
};

export const setItem = async (key: string, value: string): Promise<void> => {
  if (Platform.OS === 'web') {
    const localforage = await getLocalforage();
    await localforage.setItem(key, value);
  } else {
    await AsyncStorage.setItem(key, value);
  }
};

export const getItem = async (key: string): Promise<string | null> => {
  if (Platform.OS === 'web') {
    const localforage = await getLocalforage();
    return await localforage.getItem<string>(key);
  } else {
    return await AsyncStorage.getItem(key);
  }
};
